import { deleteMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DELETE_PRACTICE_LIST = 'DELETE_PRACTICE_LIST';
export const DELETE_PRACTICE_LIST_SUCCESS = 'DELETE_PRACTICE_LIST_SUCCESS';
export const DELETE_PRACTICE_LIST_FAILURE = 'DELETE_PRACTICE_LIST_FAILURE';

// Action Creators
export const deletePracticeList = () => ({
  type: DELETE_PRACTICE_LIST,
});

export const deletePracticeListSuccess = (users) => ({
  type: DELETE_PRACTICE_LIST_SUCCESS,
  payload: users,
});

export const deletePracticeListFailure = (error) => ({
  type: DELETE_PRACTICE_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const deletePracticeData = (external, id) => {
  return async (dispatch) => {
    dispatch(deletePracticeList());
    try {
      const response = await deleteMethodWithToken(
        url?.deletePractice + id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(deletePracticeListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(deletePracticeListFailure('error?.message'));
      }
    } catch (error) {
      dispatch(deletePracticeListFailure(error?.message));
    }
  };
};
